function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJcb = function SvgJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 800,
    width: 800,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#202121",
      enableBackground: "new"
    },
    d: "M21.517 402.282V109.717c0-16.716 13.552-30.266 30.267-30.266h-21.52C13.55 79.451 0 93.003 0 109.717V402.28c0 16.716 13.55 30.267 30.265 30.267h21.52c-16.715.002-30.268-13.551-30.268-30.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f549d"
    },
    d: "M196.197 143.37h-53.654c-26.067 0-43.58 17.514-43.58 43.58v77.954a.64.64 0 0 0 .011.115c2.057 9.774 12.302 17.143 23.83 17.143 12.727 0 22.322-8.942 22.322-20.802v-38.929h32.8v38.421c0 21.91-28.205 32.252-47.261 32.342-11.272-.047-22.318-3.509-30.307-9.502a.559.559 0 0 0-.582-.052l-.004.002a.561.561 0 0 0-.502-.002.559.559 0 0 0-.306.498v86.049c0 .307.248.557.557.557h55.174c19.452 0 42.061-18.373 42.061-42.061V143.927a.558.558 0 0 0-.559-.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b41f36"
    },
    d: "M304.016 143.37h-53.148c-26.474 0-43.58 16.908-43.58 43.077v44.036a.557.557 0 0 0 .912.427c4.639-3.868 12.118-8.478 21.408-8.478h57.148v10.396c-13.876-3.038-26.711-4.422-32.853-4.422-14.543 0-26.374 11.831-26.374 26.372l.004.161-.004.345c0 14.542 11.831 26.372 26.374 26.372 7.45 0 20.42-1.212 32.853-3.916v9.383h-57.148c-8.22 0-16.009-3.079-21.372-8.445a.555.555 0 0 0-.607-.12.555.555 0 0 0-.344.514v91.112c0 .307.248.557.557.557h54.663c19.455 0 42.065-18.373 42.065-42.061V143.927a.552.552 0 0 0-.554-.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#329947"
    },
    d: "M333.324 280.595c0 .307.25.557.557.557h23.789c6.387 0 12.202-5.816 12.202-12.2 0-6.383-5.816-12.198-12.202-12.198h-23.789a.558.558 0 0 0-.557.557v23.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#329947"
    },
    d: "M413.352 143.37h-52.646c-14.013 0-25.4 4.739-33.017 13.08v-.001s-11.069 10.798-11.069 28.606v36.82c0 .307.248.557.557.557h63.781c8.752 0 16.148 7.396 16.148 16.149s-7.396 16.148-16.148 16.148a.557.557 0 1 0 0 1.114c9.904 0 17.665 6.871 17.665 15.642 0 8.918-7.595 15.643-17.665 15.643h-63.781a.557.557 0 0 0-.557.557v82.504c0 .307.248.557.557.557h54.669c19.453 0 42.063-18.373 42.063-42.061V143.927a.557.557 0 0 0-.557-.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#329947"
    },
    d: "M333.881 252.299h23.789c6.339 0 11.694-5.355 11.694-11.694 0-6.384-5.813-12.199-12.196-12.199h-23.287a.558.558 0 0 0-.557.557v22.78c0 .307.25.556.557.556z"
  }));
};
export default SvgJcb;